import _get from 'lodash/get'
import { fromJS } from 'immutable'
import {
  setLanguagesData,
  setLanguagesProcessing,
  setLanguagesError,
  GET_LANGUAGES_DATA,
} from './actions'
import {
  getLanguages,
} from '..'

const log = console

async function getLanguagesDataHandler ({ store }) {
  const { config, auth } = store.getState()
  try {
    store.dispatch(setLanguagesProcessing({}))
    const options = {
      auth,
      server: config.getIn(['data', 'servers', 'brooklyn']),
    }
    if (auth.get('processing') !== false) {
      return
    }
    const data = await getLanguages(options)
    store.dispatch(setLanguagesData({
      data: fromJS(_get(data, 'languages')),
    }))
  } catch (error) {
    log.error(error, 'Error getting merchandising languages data.')
    store.dispatch(setLanguagesError({
      error,
    }))
  }
}

export default (store) => (next) => (action) => {
  const { type } = action
  switch (type) {
    case GET_LANGUAGES_DATA:
      getLanguagesDataHandler({ store, action })
      break
    default:
      break
  }
  next(action)
}
